import { CreateRepeatableEventForm } from '@/services/Calendar/RepeatableEvents/forms/CreateRepeatableEventForm';

export class EditRepeatableEventForm extends CreateRepeatableEventForm {
}
